import { UserTranslationKeys } from 'intl/keys';
import { TranslationKey } from 'intl/types/translationKey';
import { UserRole } from 'shared/types/userRole';

const USER_ROLE_LABEL_KEYS: Record<UserRole, TranslationKey> = {
  [UserRole.visible_no_access]: UserTranslationKeys.visibleNoAccess,
  [UserRole.standard]: UserTranslationKeys.standard,
  [UserRole.manager]: UserTranslationKeys.manager,
  [UserRole.viewer]: UserTranslationKeys.viewer,
  [UserRole.projectAdmin]: UserTranslationKeys.projectAdmin,
  [UserRole.superAdmin]: UserTranslationKeys.admin,
  [UserRole.organizationAdmin]: UserTranslationKeys.admin,
};

export function userRoleLabelKey(role: UserRole): TranslationKey {
  return USER_ROLE_LABEL_KEYS[role];
}
